
export default {
  name: 'ComponentPSmall',
  components: {},
  props: {
    text: {
      type: String,
      required: true
    },
    bold: {
      type: Boolean,
      required: false,
      default: false
    },
    white: {
      type: Boolean,
      required: false,
      default: false
    },
    center: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({}),
  computed: {},
  created() {},
  mounted() {},
  methods: {}
}
